const TYPE_ID_SYSTEM_ADMINISTRATOR = '100';

export function isAdministrator(typeId: string) {
  return typeId === TYPE_ID_SYSTEM_ADMINISTRATOR;
}
